<template>
  <div class="main">
    <div class="topLocation">
      <div class="topLocationImg"><img src="../assets/locationBlue.png" alt=""></div>
      <div class="topLocationTil">{{address}}</div>
    </div>
    <div class="topSearch">
      <div class="topSearchBox" @click="changeToPath">
        <div class="searchIcon"><img src="../assets/searchIcon.png" alt=""></div>
        <div class="searchText">请输入食堂名称或机关单位名称</div>
      </div>
    </div>
    <div id="container"></div>

    <!-- <div class="editBtn"><img src="../assets/editBtn.png" alt=""></div> -->
    <div class="scanBtn" @click="scanFunc"><img src="../assets/scanBtn.png" alt=""></div>
    <van-popup v-model="showFalse" round closeable>
      <div class="falseCont">
        <div class="fTopImg"><img src="../assets/scanFalse.png" alt=""></div>
        <div class="fTil">扫码失败</div>
        <div class="fText">{{falseCont}}</div>
      </div>
    </van-popup>
    <van-popup v-model="showTrue" round closeable>
      <div class="trueCont">
        <div class="tTil">确认支付</div>
        <div class="tCenter">
          <span class="price">{{scanAllText.mealFee}}</span>
          <!-- 2022.8.22 晚六点修改 -->
          <!-- <span class="price" v-if="scanAllText.canteenType=='食堂'">-15</span>
          <span class="price" v-if="scanAllText.canteenType=='廉政灶'">-30</span> -->
          元就餐费</div>
        <div class="tUser"><span class="tname" v-if="scanAllText&&scanAllText.workerName">{{scanAllText.workerName}}</span>在<span class="tdate" v-if="nowDate">{{nowDate}}</span></div>
        <div class="tBom">即将支付<span class="taddress" v-if="scanAllText&&scanAllText.canteenName">{{scanAllText.canteenName}}</span></div>
        <van-cell v-if="scanAllText&&scanAllText.businessUnitList.length>1" value-class="van-ellipsis" title="出差单位：" is-link :value="companyText" @click="showCompanuBox" />
        <div class="tBomBtnBox">
          <div class="tBtnLeft" @click="showTrue=false">撤回</div>
          <div class="tBtnRight" @click="getScanText2">确定</div>
        </div>
      </div>
    </van-popup>
    <van-action-sheet v-model="showNav" :actions="actions" @select="onSelectNav" get-container="body" :close-on-click-overlay="false" cancel-text="取消" />

    <van-popup v-model="showCompanu" round position="bottom">
      <van-picker
        show-toolbar
        :columns="companycolumns"
        @cancel="showCompanu = false"
        @confirm="onConfirmCompany"
      />
    </van-popup>
  </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue';
import { Dialog } from 'vant';
import { Toast } from 'vant';
import { ActionSheet } from 'vant';
import { addBaseAplus } from '../utils/zzdmd.js'
import { Cell, CellGroup } from 'vant';

Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(ActionSheet);
Vue.use(Toast);
// 全局注册
Vue.use(Dialog);
export default {
  name: "home",
  data() {
    return {
      map: null,
      lon:0,
      lat:0,
      address:'',
      markList:[],
      actions: [ { name: '高德地图' }],
      showNav:false,
      tlon:0,
      tlat:0,
      taddress:'',
      showFalse:false,
      falseCont:'',
      showTrue:false,
      scanAllText:'',
      nowDate:'',
      scanText:'',
      showCompanu:false,
      companycolumns: [],
      companyId:0,
      companyText:'请选择',
      timers:false
    };
  },
  created(){
    this.$nextTick(()=>{
      // this.initMap()
      this.getLocation()
      
    })
    this.nowDate = this.getnow()
    // this.getScanText('202263010498')
  },
  mounted(){
     this.$nextTick(()=>{
      addBaseAplus(this.$route)
    })
  },
  activated(){
    this.nowDate = this.getnow()
  },
  methods: {
    showCompanuBox(){
      this.companycolumns = []
      if(this.scanAllText&&this.scanAllText.businessUnitList.length>1){
        this.scanAllText.businessUnitList.map((item,index)=>{
          this.companycolumns.push({
            text:item.olName,
            value:item.id
          })
        })
      }
      this.showCompanu = true
    },
    onConfirmCompany(e){
      this.companyId = e.value
      this.companyText = e.text
      this.showCompanu = false
    },
    getUrlKey: function (name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    
    getLocation(){
      let _this = this;
      this.$post("api/Dingding/GetJSAPOTicket").then((res) => {
          if ( res.code == 1000) {
            if(res.data.success){
            let ticket = res.data.content.data.accessToken;
            //01 获取鉴权码
            // 02  鉴权
            dd.authConfig({
              ticket: ticket,
              jsApiList: ["getGeolocation"],
            }).then((res) => {
                dd.getGeolocation({
                  targetAccuracy: 200,
                  coordinate: 1,
                  withReGeocode: false,
                  useCache: true, //默认是true，如果需要频繁获取地理位置，请设置false
                }).then((res) => {
                  this.lon = res.longitude
                  this.lat = res.latitude
                  sessionStorage.setItem('userLon',res.longitude)
                  sessionStorage.setItem('userLat',res.latitude)
                  this.address = res.address
                  sessionStorage.setItem('userAddress',res.address)
                  let qrcode = this.getUrlKey('qrcode')
                  if(qrcode&&!sessionStorage.getItem('qrcordLock')){
                    sessionStorage.setItem('qrcordLock','1')
                    this.getScanText(qrcode)
                    this.$router.push({query:{}})
                  }
                  this.initMap()
                }).catch((err)=>{
                  if(!sessionStorage.getItem('userLon')||!sessionStorage.getItem('userLat')){
                    Dialog.confirm({
                      title: '提示',
                      message: '定位失败，请检查是否已打开定位权限',
                      confirmButtonText:'重新定位',
                      cancelButtonText:'关闭页面',
                      confirmButtonColor:'#3B87F5',
                      cancelButtonColor:'#666666'
                    }).then(() => {
                      this.getLocation()
                    }).catch(() => {
                      dd.closePage()
                    });
                  }
                })
              })
            }else{
              Dialog.confirm({
                title: '提示',
                message: '鉴权失败，请重新尝试鉴权',
                confirmButtonText:'重新鉴权',
                cancelButtonText:'关闭页面',
                confirmButtonColor:'#3B87F5',
                cancelButtonColor:'#666666'
              }).then(() => {
                window.location.reload()
              }).catch(() => {
                dd.closePage()
              });
            }
          }
        })
    },
    initMap() {
      let container = document.querySelector("#container");
      this.map = new AMap.Map(container, {
        disableSocket: true,
        viewMode: "3D",
        labelzIndex: 130,
        pitch: 0,
        center:[this.lon||118.848856,this.lat||28.970283],
        // center:[121.465177,31.228678],
        zoom: 15,
        zooms: [8, 20],
        layers: [
            // 卫星
            // new AMap.TileLayer.Satellite(),
            // 路网
            // new AMap.TileLayer.RoadNet()
        ],
        // mapStyle:'amap://styles/4c197e31948ef7767fbecd8bf3852701',
        DragEnable: false,
      })
      this.getMark()
    },
    getMark(){
      let param = {}
      this.$post('api/Canteen/GetCanteenListEasi', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.markList = res.data
            let facilities = []
            let infoWindow = []
            for (let i = 0; i < res.data.length; i++) {
                    var startIcon = new AMap.Icon({
                        size: new AMap.Size(13, 16),
                        image: require('../assets/locationYellow.png'),
                        imageSize: new AMap.Size(13, 16),
                        imageOffset: new AMap.Pixel(0, 0)
                    });
                var marker = new AMap.Marker({
                    position: new AMap.LngLat(res.data[i].cLongitude, res.data[i].cLatitude),
                    offset: new AMap.Pixel(-6.5, -16),
                    icon: startIcon, // 添加 Icon 图标 URL
                    extData:{
                      sid:res.data[i].id
                    },
                });
                marker.on('click',(e)=>{
                  // this.tlon = res.data[i].cLongitude
                  // this.tlat = res.data[i].cLatitude
                  // this.taddress = res.data[i].cDetailedAddress
                  // this.showNav = true
                  this.$router.push({path:'/canteenDetail',query:{id:res.data[i].id}})
                })
                var textMark = new AMap.Text({
                    text:res.data[i].cCanteenName,
                    anchor:'bottom-center', // 设置文本标记锚点
                    draggable:false,
                    cursor:'pointer',
                    extData:{
                      sid:res.data[i].id
                    },
                    style:{
                        'padding': '10px 12px',
                        'background': 'rgba(255, 144, 35, 0.8)',
                        'box-shadow':' 0px 2px 5px 0px rgba(4, 0, 0, 0.2)',
                        'border-radius':' 5px',
                        'border-width': 0,
                        'text-align': 'center',
                        'font-size': '12px',
                        'transform': 'translateY(-25px)',
                        'color': '#fff'
                    },
                    position: new AMap.LngLat(res.data[i].cLongitude, res.data[i].cLatitude)
                });
                textMark.on('click',(e)=>{
                  // this.tlon = res.data[i].cLongitude
                  // this.tlat = res.data[i].cLatitude
                  // this.taddress = res.data[i].cDetailedAddress
                  // this.showNav = true
                  this.$router.push({path:'/canteenDetail',query:{id:res.data[i].id}})
                })
                facilities.push(marker,textMark);
              //  let point =  new AMap.LngLat(res.data[i].cLongitude, res.data[i].cLatitude)
              //  infoWindow[i] = new AMap.InfoWindow({
              //   content: "<div style='color:#facc14;font-size:20px;margin-top:34px'>"+res.data[i].Title+"</div><div style='margin-top: 10px;font-size: 16px;'>"+res.data[i].Site+"</div><div style='margin-top: 15px;font-size: 16px;'>"+res.data[i].Conent+"</div>",  //传入 dom 对象，或者 html 字符串
              //   autoMove:true
              // });
              // this.setInfoWindow(infoWindow[i],marker,point)
            }
            this.map.add(facilities);
        }
      })
    },
    onSelectNav(item){
      if(item.name=='百度地图'){
        // dd.openLink({
        //     url: `http://api.map.baidu.com/direction?origin=latlng:${this.lat},${this.lon}|name:${this.address}&destination=latlng:${this.tlat},${this.tlon}|name:${this.taddress}&mode=driving&coord_type=gcj02&src=webapp.baidu.openAPIdemo`
        // }).then(res => {
        //     console.log(res)
        // }).catch(err => {})
      }else if(item.name=='高德地图'){
        dd.openLink({
            url: `https://uri.amap.com/navigation?from=${this.lon},${this.lat},${this.address}&to=${this.tlon},${this.tlat},${this.taddress}&coordinate=gaode&callnative=1`
        }).then(res => {
            console.log(res)
        }).catch(err => {})
      }
      this.showNav = false
    },
    changeToPath(){
      this.$router.push({path:'/search'})
    },
    getUrlKey1: function (name,url) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    scanFunc(){
      let _this = this;
      this.$post("api/Dingding/GetJSAPOTicket").then((res) => {
          if ( res.code == 1000) {
            let ticket = res.data.content.data.accessToken;
            //01 获取鉴权码
            // 02  鉴权
            dd.authConfig({
              ticket: ticket,
              jsApiList: ["scan"],
            }).then((res) => {
                // 03 判断鉴权结果后，使用获取地理位置
                dd.scan({
                  type:'qr'
                }).then((res) => {
                  this.getScanText(this.getUrlKey1('qrcode',res.text))
                })
              }).catch((err) => {
                Dialog.alert({
                  title: '提示',
                  message: '打开扫码失败',
                }).then(() => {
                  // on close
                });
              });
          }
        }).catch((err) => {
          Dialog.alert({
            title: '提示',
            message: '打开扫码失败',
          }).then(() => {
            // on close
          });
        });
    },
    getScanText(text){
      this.scanText = text
      let param = {
        QRCode:text,
        WorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        // WorkerID:102061,
        Probe:false
      }
      this.$post('api/Canteen/Estimate', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          
          this.scanAllText = res.data
          if(res.data.businessUnitList.length==1){
            this.companyId = res.data.businessUnitList[0].id
          }
          this.showTrue = true
        }else{
          this.falseCont = res.msg||res.message
          this.showFalse = true
        }
      })
    },
    getScanText2(){
      if(this.timers){
        setTimeout(()=>{
          this.timers = false
        },1000)
        return
      }
      this.timers = true
      if(this.scanAllText&&this.scanAllText.businessUnitList.length>1){
        if(!this.companyId){
          Toast({
            message: '请先选择出差单位',
            position: 'bottom',
          })
          return
        }
      }
      this.showTrue = false
      let param = {
        QRCode:this.scanText,
        WorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        // WorkerID:102061,
        Probe:true,
        Longitude:sessionStorage.getItem('userLon'),
        Latitude:sessionStorage.getItem('userLat'),
        BusinessUnit:this.companyId||0
      }
      this.$post('api/Canteen/Estimate', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.$router.push({path:'/scanSucess',query:{oid:res.data.orderID,cid:res.data.canteenID,mealFee:res.data.mealFee}})
        }else{
          this.falseCont = res.msg||res.message
          this.showFalse = true
        }
      })
    },
    getnow(dates){
      var mynow = dates?new Date(dates):new Date();//默认的获取的是当前时间
      //通过调用日期对象的方法来重新获取当前的日期时间
      //mynow.setFullYear(2016);
      var year = mynow.getFullYear();//获取年
      var month = (mynow.getMonth()+1)<10?'0'+(mynow.getMonth()+1):(mynow.getMonth()+1);//获取月
      var day = mynow.getDate()<10?'0'+mynow.getDate():mynow.getDate();//获取日
      var hour =mynow.getHours()<10?'0'+mynow.getHours():mynow.getHours();//获取小时
      var minute =mynow.getMinutes()<10?'0'+mynow.getMinutes():mynow.getMinutes();//获取分钟
      // var second =mynow.getSeconds();//获取秒
      var strdate = year+'-'+ month+"-"+day+' '+hour+':'+minute
      return strdate
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  position: relative;
}
.topLocation{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  z-index: 1;
  background: #fff;
}
.topLocationImg{
  width: 13px;
  height: 16px;
}
.topLocationImg>img{
  width: 100%;
  height: 100%;
}
.topLocationTil{
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  max-width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 10px;
}
.topSearch{
  width: 100%;
  position: absolute;
  top: 46px;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 12px;
  z-index: 1;
}
.topSearchBox{
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px 0px rgba(4, 0, 0, 0.2);
  border-radius: 18px;
  box-sizing: border-box;
  padding: 10px 11px;
  display: flex;
  align-items: center;
}
.searchIcon{
  width: 14px;
  height:14px;
}
.searchIcon>img{
  width: 100%;
  height: 100%;
}
.searchText{
  font-size: 14px;
  font-weight: 500;
  color: #999999;
  max-width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 10px;
}
.editBtn{
  width: 48px;
  height: 48px;
  position: absolute;
  top: 108px;
  right: 8px;
  z-index: 1;
}
.editBtn>img{
  width: 100%;
  height: 100%;
}
.scanBtn{
  width: 58px;
  height: 58px;
  position: absolute;
  bottom: 72px;
  right: 8px;
  z-index: 1;
}
.scanBtn>img{
  width: 100%;
  height: 100%;
}

#container {
  padding: 0px;
  margin: 0px;
  width: 100vw;
  height: 100vh;
}
div /deep/ .amap-logo{
    display: none !important;
    opacity: 0 !important
}
  div /deep/ .amap-copyright {
      display: none !important;
    opacity:0 !important;
}
.falseCont{
  box-sizing: border-box;
  padding: 50px 42px;
  background-color: #fff;
  border-radius: 5px;
  width: 80vw;
  text-align: center;
}
.fTopImg{
  width: 44px;
  height: 44px;
  margin: 0 auto;
}
.fTopImg>img{
  width: 100%;
  height: 100%;
}
.fTil{
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin-top: 15px;
}
.fText{
  font-size: 12px;
  font-weight: 500;
  color: #666666;
  margin-top: 10px;
}
.trueCont{
  box-sizing: border-box;
  padding: 12px 28px;
  background-color: #fff;
  border-radius: 5px;
  width: 80vw;
  text-align: center;
}
.tTil{
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.tCenter{
  margin-top: 24px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}
.price{
  font-size: 28px !important;
  color: #EA6363 !important;
}
.tUser{
  margin-top:12px;
  font-size: 14px;
  color:#333333;
}
.tdate{
  color:#3B87F5 !important;
}
.tBom{
  margin-top:4px;
  font-size: 14px;
  color:#333333;
}
.tBomBtnBox{
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 15px;
}
.tBtnLeft{
  padding:5px 22px;
  border-radius: 4px;
  border: 1px solid #3B87F5;
  font-size: 16px;
  color: #3B87F5;
}
.tBtnRight{
  padding:5px 22px;
  border-radius: 4px;
  font-size: 16px;
  color: #fff;
  background: #3B87F5;
}
</style>



// WEBPACK FOOTER //
// src/page/home.vue